import { render, staticRenderFns } from "./transformer.vue?vue&type=template&id=0c48c1eb&scoped=true&"
import script from "./transformer.vue?vue&type=script&lang=js&"
export * from "./transformer.vue?vue&type=script&lang=js&"
import style0 from "./transformer.vue?vue&type=style&index=0&id=0c48c1eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c48c1eb",
  null
  
)

export default component.exports